import styled from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

// import { XXSMALL_BREAKPOINT } from '../../../../style'

export const Wrapper = styled.div`
  height: 12.25rem;
  width: 12.25rem;
  overflow: hidden;
  background: ${colors.white};
  box-shadow: 0 2px 48px rgba(0, 0, 0, 0.1);
  border-radius: 1rem;
  position: relative;
`
export const InnerWrapper = styled.div`
  display: flex;
  position: absolute;
  left: -6.125rem;
  top: 0;
  animation-name: example;
  animation-duration: 8s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-delay: 2s;

  @keyframes example {
    0% {
      left: -6.125rem;
    }
    10% {
      left: -6.125rem;
    }
    20% {
      left: -30.625rem;
    }
    30% {
      left: -30.625rem;
    }
    40% {
      left: -55.125rem;
    }
    50% {
      left: -55.125rem;
    }
    60% {
      left: -79.625rem;
    }
    70% {
      left: -79.625rem;
    }
    80% {
      left: -104.125rem;
    }
    90% {
      left: -104.125rem;
    }
    100% {
      left: -6.125rem;
    }
  }

  > div {
    height: 12.25rem;
    width: 24.5rem;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      margin-bottom: 12px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/BrandDashbboardLoader/BrandDashbboardLoader.style.tsx